var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewBusinessactiveicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 168,
    viewBox: "0 0 160 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_468_32518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.5683 92.9963C58.2487 92.9963 79.0668 72.1784 79.0668 46.4982C79.0668 20.8179 58.2487 0 32.5683 0C6.88782 0 -13.9303 20.8179 -13.9303 46.4982C-13.9303 72.1784 6.88782 92.9963 32.5683 92.9963Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M103.213 174.278V181.796C103.213 184.575 101.079 186.83 98.4559 186.83H-35.2425C-37.8743 186.83 -40 184.575 -40 181.796V121.983C-40 109.091 -30.1353 98.6464 -17.9608 98.6464H19.3724C19.8325 98.6464 20.2466 98.9316 20.4399 99.3825L31.1696 122.25C31.3536 122.627 31.8598 122.627 32.0346 122.25L42.7735 99.3825C42.9576 98.9316 43.3809 98.6464 43.841 98.6464H68.5396C64.4631 106.045 62.1349 114.557 62.1349 123.612C62.1349 148.54 79.7479 169.346 103.213 174.278Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.75 169.475C139.212 169.475 159.844 148.844 159.844 123.391C159.844 97.9286 139.212 77.2975 113.75 77.2975C97.4988 77.2975 83.2079 85.7083 75.0087 98.4255C70.3616 105.612 67.6654 114.189 67.6654 123.391C67.6654 145.163 82.757 163.411 103.057 168.223C106.489 169.042 110.069 169.475 113.75 169.475ZM114.129 97.5421C115.351 97.5421 116.464 98.234 116.99 99.3213L123.377 112.398L137.651 114.493C138.843 114.671 139.826 115.501 140.204 116.638C140.581 117.775 140.273 119.03 139.419 119.87L129.069 130.06L131.522 144.461C131.721 145.647 131.224 146.843 130.241 147.555C129.257 148.267 127.956 148.346 126.883 147.782L114.139 141.012L101.395 147.782C100.322 148.346 99.021 148.257 98.0376 147.555C97.0542 146.853 96.5576 145.647 96.7562 144.461L99.1998 130.06L88.8495 119.87C87.9953 119.03 87.6973 117.775 88.0648 116.638C88.4323 115.501 89.4256 114.671 90.6176 114.493L104.882 112.398L111.269 99.3213C111.805 98.234 112.907 97.5421 114.129 97.5421Z",
    fill: "white",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_468_32518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 186.83,
    fill: "white",
    transform: "translate(-40)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBusinessactiveicon);
export default __webpack_public_path__ + "static/media/NewBusinessactiveicon.c2f7ae9ac781f4ff4981c3d28e8583bb.svg";
export { ForwardRef as ReactComponent };